import { Fragment, ReactNode } from 'react';

import { CopyIconButton } from '../copy-icon-button/copy-icon-button';

interface Props {
  children: ReactNode;
  title: string;
  showCopyButton?: boolean;
  copyObject?: any;
}

export const AdminPageSection = ({ children, title, showCopyButton = false, copyObject }: Props) => {
  return (
    <Fragment>
      <div
        className={
          'mb-psc-lg relative w-full items-center rounded-lg bg-white ' +
          'shadow-[0_2px_4px_rgba(0,0,0,0.2)] transition duration-300 ease-in-out'
        }
      >
        <div
          className={
            'w-full rounded-t-lg border-b border-gray-300 bg-gray-50 px-5 py-4 ' +
            'text-sm font-semibold text-gray-900 dark:text-gray-400'
          }
        >
          {title}
          {showCopyButton ? (
            <CopyIconButton text={JSON.stringify(copyObject)} iconColor={'text-blue-700'} position="right">
              <></>
            </CopyIconButton>
          ) : (
            <></>
          )}
        </div>
        <div className={'w-full px-5 py-5'}>{children}</div>
      </div>
    </Fragment>
  );
};
